module.exports = __webpack_public_path__ + "static/media/certificate_ascendo_logo.41ff40fb.png";